/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
import { configureStore } from '@reduxjs/toolkit';
import { applicationSlice } from './features/application/application.slice';
import { authSlice } from './features/auth/auth.slice';
import { configurationSlice } from './features/configuration/configuration.slice';
import { submissionsSlice } from './features/submissions/submissions.slice';
import { dashboardSlice } from './features/dashboard/dashboard.slice';
import { bioMaterialsSlice } from './features/bioMaterials/bioMaterials.slice';
import { autocompleteSlice } from './features/autocomplete/autocomplete.slice';
import { autofillSlice } from './features/autofill/autofill.slice';
import { alertsSlice } from './features/alerts/alerts.slice';
import { userAccountsSlice } from './features/user/userAccounts/userAccounts.slice';
import { organizationEditorSlice } from './features/organization/organizationEditor/organization.editor.slice';
import { getUsersSlice } from './features/users/get/users.get.slice';
import { inviteUsersSlice } from './features/users/invite/users.invite.slice';
import { usersSlice } from './features/users/paginate/users.slice';
import { mergeUserAccountSlice } from './features/users/merge/users.merge.slice';
import { removeUserSlice } from './features/user/remove/user.remove.slice';
import { removeUserFromOrgSlice } from './features/user/remove/user.removeFromOrg.slice';
import { userEditSlice } from './features/user/edit/user.edit.slice';
import { handleInvitationSlice } from './features/user/handleInvitation/user.handleInvitation.slice';
import { editUserRolesSlice } from './features/user/editRoles/user.edit.role.slice';
import { invitationsSlice } from './features/invitations/paginate/invitations.slice';
import { removeInvitationFromOrgSlice } from './features/invitation/remove/invitation.remove.slice';
import { resendInvitationSlice } from './features/invitation/resend/invitation.resend.slice';
import { removeUsersFromOrgSlice } from './features/users/remove/users.remove.slice';
import { dialogSlice } from './features/dialogs/dialog.slice';
import { submissionSlice } from './features/submission/submission.slice';
import { removeOrganizationSlice } from './features/organization/remove/organization.remove.slice';
import { alertDialogSlice } from './features/alertDialog/alertDialog.slice';

export const storeOptions = {
  // root reducer using slice names for the contained reducers to support direct name refactoring
  reducer: {
    [applicationSlice.name]: applicationSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [configurationSlice.name]: configurationSlice.reducer,
    [submissionsSlice.name]: submissionsSlice.reducer,
    [dashboardSlice.name]: dashboardSlice.reducer,
    [bioMaterialsSlice.name]: bioMaterialsSlice.reducer,
    [autocompleteSlice.name]: autocompleteSlice.reducer,
    [autofillSlice.name]: autofillSlice.reducer,
    [alertsSlice.name]: alertsSlice.reducer,
    [inviteUsersSlice.name]: inviteUsersSlice.reducer,
    [usersSlice.name]: usersSlice.reducer,
    [mergeUserAccountSlice.name]: mergeUserAccountSlice.reducer,
    [userEditSlice.name]: userEditSlice.reducer,
    [userAccountsSlice.name]: userAccountsSlice.reducer,
    [organizationEditorSlice.name]: organizationEditorSlice.reducer,
    [getUsersSlice.name]: getUsersSlice.reducer,
    [editUserRolesSlice.name]: editUserRolesSlice.reducer,
    [removeUserSlice.name]: removeUserSlice.reducer,
    [removeUserFromOrgSlice.name]: removeUserFromOrgSlice.reducer,
    [handleInvitationSlice.name]: handleInvitationSlice.reducer,
    [invitationsSlice.name]: invitationsSlice.reducer,
    [removeInvitationFromOrgSlice.name]: removeInvitationFromOrgSlice.reducer,
    [resendInvitationSlice.name]: resendInvitationSlice.reducer,
    [removeUsersFromOrgSlice.name]: removeUsersFromOrgSlice.reducer,
    [dialogSlice.name]: dialogSlice.reducer,
    [submissionSlice.name]: submissionSlice.reducer,
    [removeOrganizationSlice.name]: removeOrganizationSlice.reducer,
    [alertDialogSlice.name]: alertDialogSlice.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
};

export default configureStore(storeOptions);
